import { render, staticRenderFns } from "./InformacionContacto.vue?vue&type=template&id=4e912ba4&"
import script from "./InformacionContacto.vue?vue&type=script&lang=js&"
export * from "./InformacionContacto.vue?vue&type=script&lang=js&"
import style0 from "./InformacionContacto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports